module.exports = __webpack_public_path__ + "static/media/nurse_accredited1.a5cb4d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited1.png
// module id = 480
// module chunks = 0